// your normal, non-cached axios instance that is already setup.
import axios from './axios'
import cachios from 'cachios'

export default cachios.create(axios)
